<template>
  <v-data-table
    v-model="selectedRows"
    :headers="tableHeaders"
    :items="tableData"
    :items-per-page="100"
    :page="$store.state.tables.page"
    :server-items-length="$store.state.tables.itemsLength"
    :footer-props="{
      showFirstLastPage: true,
      disableItemsPerPage: true,
    }"
    :item-class="itemRowBackground"
    no-data-text="Записей нет"
    show-select
    class="elevation-1"
    group-by="parent_id"
    @pagination="paginationHandler"
  >
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title>{{ tableConfig.tableTitle }}</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>

        <div class="d-flex align-center mt-5">
          <v-switch
            :input-value="quickInsertEnabled"
            label="Быстрая вставка"
            @change="toggleQuickInsert"
          ></v-switch>
        </div>

        <v-btn
          icon
          color="error"
          class="mx-2"
          fab
          small
          @click="removeMultipleItems"
        >
          <v-icon>mdi-delete</v-icon>
        </v-btn>

        <v-btn icon>
          <v-icon>mdi-refresh</v-icon>
        </v-btn>

        <v-btn icon>
          <v-icon>mdi-content-copy</v-icon>
        </v-btn>

        <v-btn icon>
          <v-icon>mdi-printer</v-icon>
        </v-btn>

        <v-divider class="mx-5" vertical></v-divider>
        <v-btn color="primary" dark class="mb-2" @click="addNewItem">
          <v-icon class="mr-1">mdi-plus</v-icon> Добавить
        </v-btn>
      </v-toolbar>
    </template>

    <template v-slot:[`item.img_name`]="{ item }">
      <v-img
        class="table__image"
        :src="getImageLink(item)"
        lazy-src="https://i.stack.imgur.com/y9DpT.jpg"
      />
    </template>

    <template v-slot:[`item.publish`]="{ item }">
      <div @click="publishToggle(item)" class="table__publish-checkbox">
        <v-icon v-if="item.publish === 1" color="success"
          >mdi-checkbox-marked</v-icon
        >
        <v-icon v-else color="grey error-1">mdi-checkbox-blank-outline</v-icon>
      </div>
    </template>

    <template v-slot:[`item.prod_count`]="{ item }">
      <v-chip class="ma-2" :color="getProductCountColor(item.prod_count)">
        {{ item.prod_count }} /
        {{
          $store.state.tables.totalProducts[$store.state.tables.tableEntityType]
        }}
      </v-chip>
    </template>

    <template v-slot:[`item.actions`]="{ item }" style="display: none">
      <v-btn
        icon
        @click="generateItems(item.id)"
        :loading="loadingItems.includes(item.id)"
      >
        <v-icon small>mdi-upload</v-icon>
      </v-btn>
      <v-btn icon @click="editItem(item)">
        <v-icon small>mdi-pencil</v-icon>
      </v-btn>
      <v-btn icon @click="removeItem(item)">
        <v-icon small> mdi-delete </v-icon>
      </v-btn>
    </template>
  </v-data-table>
</template>

<script>
import { SET_PAGE, SET_ITEM_PUBLISH_STATUS } from "@/store/mutations.type.js";
import {
  FETCH_TABLE_DATA,
  POST_GENERATE_ITEMS,
  POST_UPDATE_ITEM,
} from "@/store/actions.type.js";
export default {
  props: {
    headers: Array,
    tableData: Array,
    tableConfig: Object,
  },

  data() {
    return {
      selectedRows: [],
      categoryTotalCounter: "?",
      loadingItems: [],
    };
  },

  computed: {
    tableHeaders() {
      let headers = this.headers
        .filter(({ name }) =>
          this.tableConfig.tableColumnsToShow.includes(name)
        )
        .map((col) => {
          return {
            text: col.name,
            value: col.name,
          };
        });

      headers.push({
        text: "Изображение",
        value: "img_name",
        sortable: false,
        align: "left",
      });

      headers.push({
        text: "Кол-во продуктов",
        value: "prod_count",
        sortable: false,
        align: "center",
      });

      headers.push({
        text: "Действия",
        value: "actions",
        sortable: false,
        align: "center",
      });

      return headers;
    },

    loading() {
      return this.tableData.length === 0 || this.headers.length === 0;
    },

    quickInsertEnabled() {
      return this.$store.state.quickInsertEnabled;
    },
  },

  watch: {
    selectedRows() {
      this.$emit("updateSelectedRows", this.selectedRows);
    },
  },

  methods: {
    async publishToggle(item) {
      this.$store.dispatch(POST_UPDATE_ITEM, {
        id: item.id,
        publish: item.publish === 0 ? true : false,
      });

      this.$store.commit(SET_ITEM_PUBLISH_STATUS, {
        id: item.id,
        status: item.publish === 0 ? 1 : 0,
      });
    },

    paginationHandler($event) {
      this.$store.commit(SET_PAGE, $event.page);
      this.$store.dispatch(FETCH_TABLE_DATA);
    },

    getImageLink({ id, alias, model_id }) {
      if (this.$store.state.tables.tableEntityType !== "products")
        return `${this.$store.state.ASSETS_ENDPOINT_URL}/${this.$store.state.tables.tableEntityType}/${id}.jpg`;

      return `https://file.print-case.com.ua/_img/${model_id}/${alias}.jpg`;
    },

    addNewItem() {
      this.$emit("addNewItemClick");
    },

    editItem(item) {
      this.$emit("editItemClick", Object.assign({}, item));
    },

    removeItem(item) {
      this.$emit("removeItemClick", item.id);
    },

    async generateItems(itemId) {
      this.loadingItems.push(itemId);

      const category =
        this.$store.state.tables.tableEntityType === "templates"
          ? "template"
          : "category";

      await this.$store.dispatch(POST_GENERATE_ITEMS, {
        type: category,
        id: itemId,
      });

      this.loadingItems = this.loadingItems.filter((item) => item !== itemId);
    },

    removeMultipleItems() {
      const ids = this.selectedRows.map(({ id }) => id);

      this.$emit("removeItemClick", ids);
    },

    toggleQuickInsert() {
      this.$store.commit("toggleQuickInsert");
    },

    itemRowBackground(item) {
      if (!item.alias) return "warning-background";
    },

    getProductCountColor(count) {
      let totalItems =
        this.$store.state.tables.totalProducts[
          this.$store.state.tables.tableEntityType
        ];
      let int = totalItems - count;

      if (int === 0) return "default";
      if (int === totalItems) return "error";

      return "warning";
    },
  },
};
</script>

<style>
.table__image {
  width: 50px;
  border: 1px solid #ececec;
  padding: 2px;
  margin: 2px;
}

.warning-background {
  background-color: rgba(247, 24, 24, 0.158) !important;
}

.table__publish-checkbox {
  cursor: pointer;
}
</style>
